import { makeStyles } from '@material-ui/core';

export const InstallmentDisabledStyle = makeStyles(() => ({
    root: {
        marginTop: '20px',
    },
}));
